// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn-outline-primary{
	color:#32879c ;
	border-color:#32879c;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#32879c;
	color:#fff;
}

.bg-white{
	background-color:#fff;
}
.headBG {
box-sizing: border-box;
background: #FFFFFF;
border: 1px solid #358696;
}

.mainDiv{
	margin-top:80px;
}

.widget{
	background: #FFFFFF;
box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
}
.widgetIcon img{
	width:50px;height:50px;
}
.widgetIcon-32 img{
	width:32px;height:32px;
}
.titlebg {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    margin-bottom: 10px;
	text-align:center;
}
.chartbox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
}
	h5, .h5 {
    font-size: 1.1rem !important;
}
p {
    line-height: 1rem !important;
}
small, .small {
    font-size: 80% !important;
}
	
table tr td {
	font-size:0.8em;
}
.accordion-button{
	font-size:0.5em;
}
.accordion-button:not(.collapsed){
	background-color:#e0e0e0;
	color:#222;
}

.filterForm > .form-label{
	font-size:0.825em;
}
.form-label{
	font-size:0.825em;
}


	
/***************************** PageTwo *******************************/
.bt-graph {
    border-right: solid 1px #b5b5b5;
}





/* media queries start here */
@media screen and (max-width: 740px) {
.titlebg {
	font-size: 0.9em;
}
}

@media screen and (max-width: 640px) {
.mainDiv{
	margin-top:120px;
}
}
	
@media screen and (max-width: 480px) {
.topHeader h2{
	font-size: 22px;
    padding-right: 3rem;
}
	.titlebg {
		font-size: 0.9em;
	}
}

@media screen and (max-width: 320px) {
	.topHeader h2{
	font-size: 16px;
		padding-right: 0rem;
	}
}

.btn-primary {
    color: #fff;
    background-color: #358696;
    border-color: #358696;
}


.btn-primary:hover {
    color: #fff;
    background-color: #358696;
    border-color: #358696;
}

.btn-primary:focus {
    color: #fff;
    background-color: #358696;
    border-color: #358696;
}

.btn-primary:active {
    color: #fff;
    background-color: #358696;
    border-color: #358696;
}


.btn-secondary{
	color: #fff;
	background: #7b7878 !important;
	border: silver;
}

.btn-secondary:hover{
 color: #fff;
	background: #7b7878;
	border: silver;
  }
  
  .btn-secondary:focus{
    color: #fff;
	background: #7b7878;
	border: silver;
  
  }
  .ev-auto{
	margin-top: -18px; 
}
.ev-auto button{
	margin-top: 18px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Jupiter/Driveanalysis_Jupiter/Filterpage_Jupiter.css"],"names":[],"mappings":";AACA;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA;CACC,qBAAqB;AACtB;AACA;AACA,sBAAsB;AACtB,mBAAmB;AACnB,yBAAyB;AACzB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB,4CAA4C;AAC5C;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;CACtB,iBAAiB;AAClB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;CACC;IACG,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;AAC7B;;AAEA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;;;AAIA,sEAAsE;AACtE;IACI,+BAA+B;AACnC;;;;;;AAMA,6BAA6B;AAC7B;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,eAAe;IACZ,mBAAmB;AACvB;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;CACA,eAAe;EACd,mBAAmB;CACpB;AACD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA;CACC,WAAW;CACX,8BAA8B;CAC9B,cAAc;AACf;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,cAAc;EACb;;EAEA;IACE,WAAW;CACd,mBAAmB;CACnB,cAAc;;EAEb;EACA;CACD,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB","sourcesContent":["\n.btn-outline-primary{\n\tcolor:#32879c ;\n\tborder-color:#32879c;\n}\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\n\tbackground-color:#32879c;\n\tcolor:#fff;\n}\n\n.bg-white{\n\tbackground-color:#fff;\n}\n.headBG {\nbox-sizing: border-box;\nbackground: #FFFFFF;\nborder: 1px solid #358696;\n}\n\n.mainDiv{\n\tmargin-top:80px;\n}\n\n.widget{\n\tbackground: #FFFFFF;\nbox-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n}\n.widgetIcon img{\n\twidth:50px;height:50px;\n}\n.widgetIcon-32 img{\n\twidth:32px;height:32px;\n}\n.titlebg {\n    font-size: 1.2em;\n    color: #000;\n    font-weight: 500;\n    margin-bottom: 10px;\n\ttext-align:center;\n}\n.chartbox{\n\tbackground: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n    /* font-size: 14px; */\n}\n\th5, .h5 {\n    font-size: 1.1rem !important;\n}\np {\n    line-height: 1rem !important;\n}\nsmall, .small {\n    font-size: 80% !important;\n}\n\t\ntable tr td {\n\tfont-size:0.8em;\n}\n.accordion-button{\n\tfont-size:0.5em;\n}\n.accordion-button:not(.collapsed){\n\tbackground-color:#e0e0e0;\n\tcolor:#222;\n}\n\n.filterForm > .form-label{\n\tfont-size:0.825em;\n}\n.form-label{\n\tfont-size:0.825em;\n}\n\n\n\t\n/***************************** PageTwo *******************************/\n.bt-graph {\n    border-right: solid 1px #b5b5b5;\n}\n\n\n\n\n\n/* media queries start here */\n@media screen and (max-width: 740px) {\n.titlebg {\n\tfont-size: 0.9em;\n}\n}\n\n@media screen and (max-width: 640px) {\n.mainDiv{\n\tmargin-top:120px;\n}\n}\n\t\n@media screen and (max-width: 480px) {\n.topHeader h2{\n\tfont-size: 22px;\n    padding-right: 3rem;\n}\n\t.titlebg {\n\t\tfont-size: 0.9em;\n\t}\n}\n\n@media screen and (max-width: 320px) {\n\t.topHeader h2{\n\tfont-size: 16px;\n\t\tpadding-right: 0rem;\n\t}\n}\n\n.btn-primary {\n    color: #fff;\n    background-color: #358696;\n    border-color: #358696;\n}\n\n\n.btn-primary:hover {\n    color: #fff;\n    background-color: #358696;\n    border-color: #358696;\n}\n\n.btn-primary:focus {\n    color: #fff;\n    background-color: #358696;\n    border-color: #358696;\n}\n\n.btn-primary:active {\n    color: #fff;\n    background-color: #358696;\n    border-color: #358696;\n}\n\n\n.btn-secondary{\n\tcolor: #fff;\n\tbackground: #7b7878 !important;\n\tborder: silver;\n}\n\n.btn-secondary:hover{\n color: #fff;\n\tbackground: #7b7878;\n\tborder: silver;\n  }\n  \n  .btn-secondary:focus{\n    color: #fff;\n\tbackground: #7b7878;\n\tborder: silver;\n  \n  }\n  .ev-auto{\n\tmargin-top: -18px; \n}\n.ev-auto button{\n\tmargin-top: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
